import { ReelsMatrix, ReelsSymbols } from "onearm";

import { apiSpinToMatrix, evaluatePaylines } from "./SlotMath.js";

export class SpinResultMapper {
    constructor({ slotDefinition }) {
        this._slotDefinition = slotDefinition;
        this._reelsSymbols = new ReelsSymbols(slotDefinition.symbols);
    }

    parse(data, { bet }) {
        return parseSpinResponse(data, {
            bet,
            reelsSymbols: this._reelsSymbols,
            slotDefinition: this._slotDefinition,
        });
    }
}

export function parseSpinResponse(data, { bet, reelsSymbols, slotDefinition }) {
    const { spin, after_balance } = data;
    const plainMatrix = apiSpinToMatrix(spin, slotDefinition);
    const reelsMatrix = ReelsMatrix.fromSpinElements(spin, reelsSymbols);
    const pays = evaluatePaylines(plainMatrix, {
        paylines: slotDefinition.paylines,
        paytable: slotDefinition.paytable,
        wild: slotDefinition.wild,
        scatter: slotDefinition.scatter,
        bet,
    });
    const computedWin = pays.reduce((sum, pay) => sum + pay.win, 0);

    return {
        matrix: reelsMatrix,
        pays,
        win: computedWin,
        balance: after_balance,
    };
}
